import React from 'react';
import { FadeIn } from './FadeIn';
import { BrainCircuit } from 'lucide-react';
export function SolutionSection() {
  return <section className="py-12 sm:py-24 px-5 sm:px-8 bg-depto-brown text-depto-cream relative overflow-hidden" data-id="element-143">
      <div className="absolute top-0 left-0 w-full h-full opacity-5" data-id="element-144">
        <div className="absolute top-10 left-10 w-64 h-64 bg-depto-amber rounded-full blur-3xl" data-id="element-145"></div>
        <div className="absolute bottom-10 right-10 w-64 h-64 bg-depto-amber rounded-full blur-3xl" data-id="element-146"></div>
      </div>

      <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-147">
        <FadeIn data-id="element-148">
          <div className="flex justify-center mb-6" data-id="element-149">
            <BrainCircuit className="w-16 h-16 text-depto-amber" data-id="element-150" />
          </div>
          <h2 className="text-sm font-sans font-bold tracking-widest text-depto-amber uppercase mb-4" data-id="element-151">
            Presentamos
          </h2>
          <h3 className="text-4xl sm:text-5xl mb-10 leading-tight" data-id="element-152">
            El Mecanismo de Agotamiento Cognitivo
          </h3>

          <div className="bg-white/10 p-8 rounded-3xl backdrop-blur-sm border border-white/10 mb-10" data-id="element-153">
            <p className="text-xl sm:text-2xl font-serif text-depto-amber mb-6" data-id="element-154">
              ¿Sabías que 15 minutos de olfato intenso cansan a un perro lo
              mismo que 45 minutos de corrida?
            </p>
            <p className="text-lg text-depto-cream/90 leading-relaxed" data-id="element-155">
              DEPTO-DOG es un sistema diseñado para la vida real en Argentina.
              No necesitás un paseador caro ni un patio de 50 metros. Tu
              departamento es el gimnasio mental que tu perro necesita.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}